// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p4wFn3sltuDZiTNZTDAQ{cursor:pointer;display:inline;text-decoration:none}`, "",{"version":3,"sources":["webpack://./src/Libs/yarrr/components/Link/Link.styl"],"names":[],"mappings":"AAAA,sBACI,cAAO,CACP,cAAS,CACT,oBAAiB","sourcesContent":[".link\n    cursor pointer\n    display: inline;\n    text-decoration: none;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `p4wFn3sltuDZiTNZTDAQ`
};
export default ___CSS_LOADER_EXPORT___;
